import { render, staticRenderFns } from "./Responsaveis.vue?vue&type=template&id=00284f0d&"
import script from "./Responsaveis.vue?vue&type=script&lang=js&"
export * from "./Responsaveis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports